import { useMemo, useState } from "react";
import { TrendingUp } from "lucide-react";
import { ToolLayout, TwoCol } from "@/components/tools/ToolLayout";
import { SectionCard, Field, MoneyInput, SliderRow, StatCard, compactINR } from "@/components/tools/kit";
import { GrowthArea, SplitDonut } from "@/components/tools/charts";
import { sip } from "@/lib/calculators";

export default function Sip() {
  const [monthly, setMonthly] = useState(25000);
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(15);
  const [stepUp, setStepUp] = useState(0);
  const r = useMemo(() => sip({ monthly, rate, years, stepUp }), [monthly, rate, years, stepUp]);
  return (
    <ToolLayout title="SIP Calculator" subtitle="See how monthly investing compounds over time" icon={TrendingUp} accent="#2D6A4F">
      <TwoCol
        left={
          <SectionCard title="Your SIP">
            <div className="space-y-5">
              <Field label="Monthly investment"><MoneyInput testid="sip-monthly" value={monthly} onChange={setMonthly} helper={compactINR(monthly) + " / month"} /></Field>
              <Field label="Expected return (p.a.)" hint={rate + "%"}><SliderRow testid="sip-rate" value={rate} min={1} max={25} step={0.5} suffix="%" onChange={setRate} /></Field>
              <Field label="Time period" hint={years + " yrs"}><SliderRow testid="sip-years" value={years} min={1} max={40} suffix=" yr" onChange={setYears} /></Field>
              <Field label="Annual step-up" hint={stepUp + "%"}><SliderRow testid="sip-stepup" value={stepUp} min={0} max={25} suffix="%" onChange={setStepUp} /></Field>
            </div>
          </SectionCard>
        }
        right={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <StatCard testid="sip-invested" label="Invested" value={compactINR(r.invested)} accent="#2A6F7F" />
              <StatCard testid="sip-gains" label="Est. Gains" value={compactINR(r.gains)} accent="#D99B26" />
              <StatCard testid="sip-value" label="Future Value" value={compactINR(r.futureValue)} accent="#2D6A4F" big />
            </div>
            <SectionCard title="Growth over time"><GrowthArea data={r.points} keys={[{ key: "value", name: "Value", color: "#2D6A4F" }, { key: "invested", name: "Invested", color: "#D99B26" }]} /></SectionCard>
            <SectionCard title="Invested vs Gains"><SplitDonut segments={[{ name: "Invested", value: Math.round(r.invested), color: "#2A6F7F" }, { name: "Gains", value: Math.round(r.gains), color: "#D99B26" }]} /></SectionCard>
          </>
        }
      />
    </ToolLayout>
  );
}
